// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"663c1f60","392":"2ed1fa6e","508":"dabde1e4","606":"8e56e5eb","651":"2e3bde9e","853":"c5ebf6ed","872":"51afed75"}[chunkId] + ".chunk.css";
};